import { PlateFloatingLink } from "@udecode/plate";

export const linkPlugin = {
  renderAfterEditable: PlateFloatingLink,
};
